import {
  ADD_FILTER,
  ADD_TAG_FILTER,
  CLEAR_FILTER,
  REMOVE_SINGLE_FILTER,
  REMOVE_SINGLE_TAG_FILTER
} from '@/store/mutation-types'
import { PageKey } from '@/helpers/filter-helper'
import { localStorageService } from '@/services/local-storage-service'
import Vue from 'vue'

import _ from 'lodash'

const LOCAL_STORAGE_PAGE_KEYS = [PageKey.TRIAL_DETAIL]

export const namespaced = false
export const state = {
  filters: {},
  tagFilters: {}
}
export const mutations = {
  [ADD_FILTER](state, { pageKey, filters }) {
    const filter = {}
    if (LOCAL_STORAGE_PAGE_KEYS.includes(pageKey)) {
      localStorageService.setItem(pageKey, filters)
    }
    _.set(filter, pageKey, filters)
    state.filters = { ...state.filters, ...filter }
  },
  [ADD_TAG_FILTER](state, { pageKey, tagFilters }) {
    const pageKeyedTagFilters = {}
    _.set(pageKeyedTagFilters, pageKey, tagFilters)
    state.tagFilters = { ...state.tagFilters, ...pageKeyedTagFilters }
  },
  [CLEAR_FILTER](state, pageKey) {
    state.filters[pageKey] = {}
  },
  [REMOVE_SINGLE_FILTER](state, { pageKey, filterId }) {
    Vue.delete(state.filters[pageKey], filterId)
  },
  [REMOVE_SINGLE_TAG_FILTER](state, { pageKey, tagFilterName }) {
    const indexToDelete = _.indexOf(state.tagFilters[pageKey], tagFilterName)
    Vue.delete(state.tagFilters[pageKey], indexToDelete)
  }
}
export const actions = {
  [ADD_FILTER]({ commit }, { pageKey, filters }) {
    commit(ADD_FILTER, { pageKey, filters })
  },
  [ADD_TAG_FILTER]({ commit }, { pageKey, tagFilters }) {
    commit(ADD_TAG_FILTER, { pageKey, tagFilters })
  },
  [CLEAR_FILTER]({ commit }, pageKey) {
    commit(CLEAR_FILTER, pageKey)
  },
  [REMOVE_SINGLE_FILTER]({ commit }, { pageKey, filterId }) {
    commit(REMOVE_SINGLE_FILTER, { pageKey, filterId })
  },
  [REMOVE_SINGLE_TAG_FILTER]({ commit }, { pageKey, tagFilterName }) {
    commit(REMOVE_SINGLE_TAG_FILTER, { pageKey, tagFilterName })
  }
}

export const getters = {
  getFilterByPageKey: state => pageKey => {
    let filter = state.filters[pageKey]
    if (_.isNil(filter)) {
      filter = localStorageService.getItem(pageKey)
    }
    return filter
  },
  getTagFilterByPageKey: state => pageKey => {
    return state.tagFilters[pageKey] || []
  },
  filterCaseWithTagsAndFields: (state, getters) => ({ caseDetailFieldMap, tagNamesOnCase }) => {
    const noTagFiltersExist = _.isEmpty(getters.getTagFilterByPageKey(PageKey.CASE))
    const noNonTagFiltersExist = _.isEmpty(getters.getFilterByPageKey(PageKey.CASE))
    if (noTagFiltersExist && noNonTagFiltersExist) {
      return false
    }
    if (noTagFiltersExist && getters.containsFilterValues(caseDetailFieldMap)) {
      return false
    }
    if (noNonTagFiltersExist && getters.containsTagFilterValues(tagNamesOnCase)) {
      return false
    }
    if (
      getters.containsFilterValues(caseDetailFieldMap) &&
      getters.containsTagFilterValues(tagNamesOnCase)
    ) {
      return false
    }
    return true
  },
  containsFilterValues: state => caseDetailFieldMap => {
    return _.every(state.filters[PageKey.CASE], (filter, key) => {
      const detailValue = _.get(caseDetailFieldMap, key)
      const returnValue = _.intersection(filter.value, detailValue).length > 0
      return returnValue
    })
  },
  containsTagFilterValues: (state, getters) => tagsOnCase => {
    let requiredCaseTags = getters.getTagFilterByPageKey(PageKey.CASE)
    return _.every(requiredCaseTags, tagFilterName => {
      return _.includes(tagsOnCase, tagFilterName)
    })
  }
}
